import Vue from "vue";
import Router from "vue-router";

const Home = () => import("@/views/Home");
const Birthday = () => import("@/views/Birthday");
const Friends = () => import("@/views/Friends");
const BirthdayRouter = () => import("@/views/BirthdayRouter");

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: Home,
      name: "Home"
    },
    { path: "/index.html", component: Home }, // Fix for PWA at /index.html
    {
      path: "/birthday",
      component: BirthdayRouter,
      children: [
        {
          path: "2019",
          name: "BirthdayWeek2019",
          component: Birthday,
          props: { year: "2019" }
        },
        {
          path: "2020",
          name: "BirthdayWeek2020",
          component: Birthday,
          props: { year: "2020" }
        },
        {
          path: "friends-2020",
          name: "Friends2020",
          component: Friends,
          props: { year: "2020" }
        },
        {
          path: "2021",
          name: "BirthdayWeek2021",
          component: Birthday,
          props: { year: "2021" }
        }
      ]
    }
  ]
});
